<template>

    <section class="dd-m-carousel dd-m-carousel--lites dd-m-carousel--custom-dots">

        <loading type="banner" v-if="isLoading"></loading>

        <div class="dd-l-container__wrapper dd-l-container__wrapper--full" v-if="results.length">
            <div class="dd-m-carousel--lites__content">
                <h2 class="dd-m-carousel--lites__title">{{title}}</h2>

                <div class="dd-m-carousel__variable-slider">
                    <Slick ref="slick" :options="slickOptions">
                        <card-lite :hide-card-title="hideCardTitle" v-for="(item, index) in results" :item="item"
                                   :key="index"></card-lite>
                    </Slick>
                </div>
            </div>
        </div>
    </section>

</template>
<script>
    import CategoryService from '../providers/api/category-service';
    import SlickOptions from '../providers/slick';
    import Slick from "vue-slick";
    import Loading from "./loading";
    import CardLite from "./cards/card-lite";

    const slickOptions = new SlickOptions(),
        categoryService = new CategoryService();

    export default {
        name: 'banner-list-lites',
        components: {CardLite, Loading, Slick},
        props: ['hideCardTitle', 'perPage', 'title', 'slug'],
        data: () => {
            return {
                lang: '',
                results: [],
                slickOptions: slickOptions.getDefault(true),
                isLoading: false
            }
        },
        mounted() {
            this.lang = language !== 'en' ? '/' + language : '';

            if (this.slug) {
                this.isLoading = true;
                categoryService.doGetCategoryBySlug(this.slug)
                    .then((res) => {
                        res.data.data.subcategories.map((item) => {
                            item.link = `${this.lang}/categoria/${this.slug}/${item.slug}`;
                            this.results.push(item);
                        });

                        this.isLoading = false;
                    })
                    .catch(() => this.isLoading = false);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/subcategories.vue